import {
  Alert,
  Box,
  CircularProgress,
  darken,
  lighten,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "reactflow/dist/style.css";
import { getLocalMapConfig } from "../../../../utils/easyMapsLocalConfig";
import SliderBarMaps_ from "../../../../componentes/easyMaps/sideBarEasyMaps";
import api from "../../../../services/api";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import ReactFlowMapas from "./reactFlowMapa";
import { ReactComponent as BarIcon } from "../../../../assets/easyMaps/titlebar.svg";
import LoadingUpdate_ from "../../../../componentes/easyMaps/loadingUpdate";
import { MapaContext, SnackbarState } from "../../../../contexts/mapaContext";
import ToastAlert from "../../../../componentes/easyMaps/toastAlert";
import { ToastContainer } from "react-toastify";
import { network } from "../../../../schemas/elements";
import AlertModal from "../../../../componentes/alertModal";
import { Edge } from "reactflow";
import { Socket } from "socket.io-client";

const SliderBarMaps = SliderBarMaps_ as any;
const LoadingUpdate = LoadingUpdate_ as any;

interface MapaTopologiaProps {
  socketCliente: Socket;
}
interface IMapConnection extends network.monitor.IConnection {
  config?: ConnectionConfig;
  entangled?: boolean;
  destinationId?: string;
  referenceId?: string;
  [key: string]: unknown;
}

interface XYZoom {
  x: number;
  y: number;
  zoom: number;
}

const MapaTopologia = ({ socketCliente }: MapaTopologiaProps) => {
  const tipo = "easymon";
  const theme = useTheme();
  const [snackbar, setSnackbar] = useState<SnackbarState | null>(null);
  const [openAccessDenied, setOpenAccessDenied] = useState(false);
  const [produtos, setProdutos] = useState<any>(false);
  const [map, setMap] = useState<any>({});
  const [configurationMap, setConfigurationMap] = useState<any | null>(null);
  const [elements, setElements] = useState<Map<string, MapElement>>(new Map());
  const [elementSelected, setElementSelected] = useState<MapElement | null>(
    null,
  );
  const [connections, setConnections] = useState<Map<string, IMapConnection>>(
    new Map(),
  );
  const [connectionSelected, setConnectionSelected] =
    useState<IMapConnection | null>(null);
  const [edgeSelected, setEdgeSelected] = useState<
    (Edge & { data: IMapConnection }) | null
  >(null);

  const [checkChanges, setCheckChanges] = useState<boolean>(false);
  const [elementsConnected, setElementsConnected] = useState<any[] | null>([]);
  const [fullScreem, setFullScreem] = useState<boolean>(false);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [iconsElements, setIconsElements] = useState<MapImage[]>([]);
  const [openRightBar, setOpenRightBar] = useState<boolean>(false);
  const [mapas, setMapas] = useState<
    { nome: string; id: string; tipo: string }[]
  >([]);
  const [sinc, setSinc] = useState<boolean>(false);
  const sincRef = useRef<boolean>(false);
  const [focusNodeId, setFocusNodeId] = useState<string | null>(null);
  const [coordenadasFlow, setCoordenadasFlow] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [loadingMap, setLoadingMap] = useState<boolean>(true);
  const [loadinButtonEnlace, setLoadinButtonEnlace] = useState<boolean>(false);
  const [collapse, setCollapse] = useState<boolean>(false);
  const [lastCollectData, setLastCollectData] = useState<any>(null);

  // atualização otimização
  const [hostsDataMap, setHostsDataMap] = useState<
    Map<string, network.monitor.IHost[]>
  >(new Map());
  const [alertsDataMap, setAlertsDataMap] = useState<
    Map<string, network.monitor.IAlert[]>
  >(new Map());
  const [connectionsDataMap, setConnectionsDataMap] = useState<
    Map<string, IMapConnection>
  >(new Map());
  const [configElementDataMap, setConfigElementDataMap] = useState<
    Map<string, network.monitor.IConfig>
  >(new Map());

  const [soundState, setSoundState] = useState(false);
  const [newAlerts, setNewAlerts] = useState<network.monitor.IAlert[]>([]);
  const [connectionMode, setConnectionMode] = useState<string>("selection");

  //const elementsFromMap = useMemo(() => [...elements?.values()], [elements]);
  const connectionsFromMap = useMemo(
    () => Array.from(connections?.values() || []),
    [connections],
  );
  const [
    connectionsDataMapPercentTraffic,
    setConnectionsDataMapPercentTraffic,
  ] = useState(new Map());
  const [connectionsDataMapPercentPower, setConnectionsDataMapPercentPower] =
    useState(new Map());

  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  const { config, configLayer, setConfigLayer } =
    useOutletContext<EasyMapsLayoutContext>();

  const { id } = useParams();
  const navigate = useNavigate();
  const editmodeRef = useRef<boolean>();

  const isMobile =
    (navigator as any).userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const xyZoomFromUrl: XYZoom = useMemo(() => {
    const url = new URL(window.location.href);
    const xURL = url.searchParams.get("x");
    const yURL = url.searchParams.get("y");
    const zoomURL = url.searchParams.get("zoom");

    return {
      x: xURL ? Number(xURL) : NaN,
      y: yURL ? Number(yURL) : NaN,
      zoom: zoomURL ? Number(zoomURL) : NaN,
    };
  }, []);

  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1500,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
    editMode: {
      position: "absolute",
      zIndex: 1203,
      fontSize: "13px",
      border:
        (fullScreem ? "4px" : "2px") + " solid " + theme.palette.secondary.main,
      display: "flex",
      alignItems: "stop",
      justifyContent: "center",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      //boxShadow: "inset 0px 0px 10px 0px " + theme.palette.color.alerts.info,
    },
    dotEditMode: {
      mt: "-2px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "fit-content",
    },
    textEditMode: {
      mt: "-27px",
      color: "white",
      fontSize: "15px",
      width: "fit-content",
    },
    rowContainer: {
      mt: "-27px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      width: "max-content",
    },
    modeChip: {
      backgroundColor: lighten(theme.palette.secondary.main, 0.4),
      border: `1px solid ${theme.palette.secondary.main}`,
      color: darken(theme.palette.secondary.main, 0.4),
      fontWeight: 600,
      fontSize: "12px",
      height: "24px",
      borderRadius: "16px",
    },
    chipDot: {
      fontSize: "9px !important",
      color: `${theme.palette.secondary.main} !important`,
      marginLeft: "6px",
    },
    toastContainer: {
      zIndex: fullScreem ? 1501 : 1200,
      marginTop: (sinc || loadingMap ? 55 : 0) + (fullScreem ? 0 : 60) + "px",
      marginRight: elementSelected ? "355px" : "0",
      visibility: editMode ? ("hidden" as const) : ("visible" as const),
    },
    connectionModeChip: {
      position: "absolute",
      zIndex: 1100,
      top: editMode ? "120px" : "20px",
      left: "20px",
      transition: "top 0.3s ease",
    },
  };

  useEffect(() => {
    if (newAlerts.length === 0) return;

    newAlerts.forEach((alert, index) => {
      if (!alert.elementId) return;
      const element = elements.get(alert.elementId);

      ToastAlert({
        alert,
        focus: setFocusNodeId,
        element,
        theme,
        sound: index === 0 && soundState, // Toca o som apenas para o primeiro alerta da lista
      });
    });

    setNewAlerts([]);
  }, [newAlerts]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (config) {
      updateDataElementSocket();
    }
  }, [config]);

  useEffect(() => {
    editmodeRef.current = editMode;
    if (!editMode) {
      updateDataElementSocket();
    }
  }, [editMode]);

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;

    const elementData = elements?.get(elementSelected.id);
    if (elementData) {
      setElementSelected({
        ...elementData,
      });
    }
  }, [elements]);

  useEffect(() => {
    if (connectionSelected == null || checkChanges) return;
    const connectionData = connections?.get(connectionSelected.id);
    if (connectionData) {
      setConnectionSelected({
        ...connectionData,
      });
    }
  }, [connections]);

  useEffect(() => {
    if (!id || !config) return;
    handleApi();
  }, [id, config]);

  useEffect(() => {
    if (!id || !config) return;
    // atualiza as confi de layer do mapa para o default
    if (!configLayer?.[id]) {
      setConfigLayer((prev) => ({
        ...(prev || {}),
        [id]: "trafego",
      }));
    }
    let timeInterval = config?.configuracoes?.top?.atualizacao || 60000;
    const interval = window.setInterval(() => {
      updateDataElementSocket();
    }, timeInterval);

    return () => window.clearInterval(interval);
  }, [id, config]);

  async function handleApi() {
    let accessDenied = false;
    try {
      setLoadingMap(true);
      setElementSelected(null);
      setConnectionSelected(null);
      await handleApiGetMap(id as string);
      await Promise.all([
        handleApiGetProdutos(tipo),
        handleApiGetMaps(),
        handleApiGetElements(id as string),
        getIconDB(),
      ]);
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status === 403) {
        accessDenied = true;
        return;
      }
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      if (!accessDenied) setLoadingMap(false);
    }
  }

  //-----funcoes de chamada a api
  async function handleApiGetElements(id: string) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/easyMaps/element/findMany", {
        mapId: id,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const data = response.data;

        // transforma os elements em MAP
        let elements = new Map<string, MapElement>(
          data.responseAlerts.map((el: MapElement) => [el.id, el]),
        );
        let connections = new Map<string, IMapConnection>(
          data.connections.map((el: IMapConnection) => [el.id, el]),
        );

        setElements(elements);
        setConnections(connections);
        updateDataElementSocket();
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetMap(mapId: string) {
    try {
      const response = await api.post("/easyMaps/map/findMapById", {
        mapId,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        const { ConfigMapEasyMaps, ...map } = response.data;
        setMap(map);
        const base = ConfigMapEasyMaps
          ? ConfigMapEasyMaps
          : { configuracoes: config?.configuracoes?.top || null };
        const local = getLocalMapConfig(mapId);
        setConfigurationMap(
          local
            ? { ...base, configuracoes: { ...base.configuracoes, ...local } }
            : base,
        );
      }
    } catch (error: any) {
      console.error(error);
      if (error?.response?.status == 403) {
        setOpenAccessDenied(true);
        throw error;
      }
      if (error?.response?.status == 404) navigate("/easyMaps/pages/notFound");
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      //setLoadingProdutos(false);
    }
  }
  async function updateDataElementSocket() {
    if (editmodeRef.current || sincRef.current) return;

    try {
      sincRef.current = true;
      setSinc(true);
      const responseBuffer = await api.get("/easyMaps/map/lastData", {
        params: { mapId: id },
        responseType: "arraybuffer",
      });
      sincRef.current = false;
      setSinc(false);
      setNewAlerts([]);

      if (responseBuffer.status !== 200) {
        console.error("Error na resposta da última coleta:", responseBuffer);
        setSnackbar({
          children: "Error: Não foi possível sincronizar os elementos",
          severity: "error",
        });
      } else {
        // transforma os elements proto em data
        const message = (network.monitor.ElementResponseRoot.decode as any)(
          new Uint8Array(responseBuffer.data),
        );
        const response = network.monitor.ElementResponseRoot.toObject(message, {
          defaults: true,
          longs: Number,
        });

        // trnsforma os elements em MAP
        const updatedData = response;
        const newHostsMap = new Map<string, network.monitor.IHost[]>();
        const newAlertsMap = new Map<string, network.monitor.IAlert[]>();
        const newConnectionsMap = new Map<string, IMapConnection>();
        const configElementMap = new Map<string, network.monitor.IConfig>();
        const connGroupedByPercentegeTrafego: Record<string, string[]> = {};
        const connGroupedByPercentegePotencia: Record<string, string[]> = {};

        for (const el of updatedData.elementosResponse) {
          // hosts por elemento
          if (el.hosts?.length) {
            newHostsMap.set(el.id, el.hosts);
          }

          // conexões concatenadas
          for (const conn of el.connections) {
            //trafego
            if (conn?.corTraffic?.label) {
              if (conn.corTraffic.label in connGroupedByPercentegeTrafego) {
                connGroupedByPercentegeTrafego[conn.corTraffic.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegeTrafego[conn.corTraffic.label] = [
                  conn.id,
                ];
              }
            }
            //potencia
            if (conn?.corPower?.label) {
              if (conn.corPower.label in connGroupedByPercentegePotencia) {
                connGroupedByPercentegePotencia[conn.corPower.label].push(
                  conn.id,
                );
              } else {
                connGroupedByPercentegePotencia[conn.corPower.label] = [
                  conn.id,
                ];
              }
            }

            newConnectionsMap.set(conn.id, conn as unknown as IMapConnection);
          }

          // alerts por elemento (ou por host, se preferir)
          if (el.alerts?.length) {
            newAlertsMap.set(el.id, el.alerts);

            // somente os novos
            const freshAlerts = el.alerts.filter(
              (alert: network.monitor.IAlert) => alert.isNew,
            );

            if (freshAlerts.length > 0) {
              setNewAlerts((prev) => {
                const existingKeys = new Set(
                  prev.map((a) => `${a.triggerid}-${a.eventid}`),
                );

                const filtered = freshAlerts.filter(
                  (a) => !existingKeys.has(`${a.triggerid}-${a.eventid}`),
                );

                return [...prev, ...filtered];
              });
            }
          }
          if (el.config) {
            configElementMap.set(el.id, el.config);
          }
        }

        setHostsDataMap(newHostsMap);
        setConfigElementDataMap(configElementMap);
        setAlertsDataMap(newAlertsMap);
        setConnectionsDataMap(newConnectionsMap);
        setLastCollectData(new Date(updatedData?.dataColeta) || null);

        setConnectionsDataMapPercentTraffic(
          new Map(Object.entries(connGroupedByPercentegeTrafego)),
        );
        setConnectionsDataMapPercentPower(
          new Map(Object.entries(connGroupedByPercentegePotencia)),
        );
      }
    } catch (error) {
      sincRef.current = false;
      setSinc(false);
      console.error("Error ao atualizar os dados dos elementos:", error);
      setSnackbar({
        children: "Error: Não foi possível atualizar",
        severity: "error",
      });
    }
  }
  async function handleApiGetMaps() {
    try {
      const response = await api.get("/easyMaps/map/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        if (response.data) {
          setMapas(
            response.data.map((map: any) => ({
              nome: map.titulo,
              id: map.id,
              tipo: map.tipo,
            })),
          );
        }
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  async function handleApiGetProdutos(tipo: string) {
    try {
      //setLoadingProdutos(true);
      const response = await api.post("/cliente/produto/findMany", {
        tipo,
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar Clientes",
          severity: "error",
        });
      } else {
        setProdutos(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      //setLoadingProdutos(false);
    }
  }
  async function getIconDB() {
    try {
      const response = await api.get("/easyMaps/img/findMany");
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error: any) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      // setHostLoading(false);
    }
  }
  //----funcoes do socket
  async function handleCreateLink(
    connection: IMapConnection,
    edgeSelected: any,
    line: string,
    capacidade: string,
    animation: string,
    hostOriginId: string,
    flagLimiteAutomatico: boolean,
    flagCapacidadeAutomatica: boolean,
    limiteSuperiorPowerRX: number,
    limiteInferiorPowerRX: number,
    limiteSuperiorPowerTX: number,
    limiteInferiorPowerTX: number,
    sourceHandle: string,
    targetHandle: string,
    viewTypeLabel: string,
    interfaceDescription: string,
    interfaceName: string,
    edgeLabelSize: number,
  ) {
    try {
      setLoadinButtonEnlace(true);
      let createConnection = connection;
      createConnection.positionHandlers =
        edgeSelected?.data?.positionHandlers?.map((value: any) => {
          return { ...value, active: -1 };
        }) ?? [];
      createConnection.config = {
        type: line ?? "reta",
        sourceHandle: sourceHandle || edgeSelected?.sourceHandle || "right",
        targetHandle: targetHandle || edgeSelected?.targetHandle || "left",
        capacidade,
        animation,
        hostOriginId: hostOriginId || null,
        flagLimiteAutomatico,
        flagCapacidadeAutomatica,
        limiteSuperiorPowerRX,
        limiteInferiorPowerRX,
        limiteSuperiorPowerTX,
        limiteInferiorPowerTX,
        viewType: viewTypeLabel,
        interfaceDescription,
        interfaceName,
        edgeLabelSize,
      };
      //return;
      const response = await api.post("/easyMaps/link", createConnection);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data?.link) {
          setConnections((prev) => {
            let next = new Map(prev);
            next.set(response.data.link.id, { ...response.data.link });
            return next;
          });
          //setConnectionSelected(response.data?.link);
          setConnectionSelected(null);
          setEdgeSelected(null);
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação via socket"
        } `,
        severity: "error",
      });
    } finally {
      setLoadinButtonEnlace(false);
      setCheckChanges(false);
    }
  }
  const handleUpdateLink = async (
    connection: IMapConnection,
    edgeSelected: any,
    line: string,
    capacidade: string,
    animation: string,
    hostOriginId: string,
    flagLimiteAutomatico: boolean,
    flagCapacidadeAutomatica: boolean,
    limiteSuperiorPowerRX: number,
    limiteInferiorPowerRX: number,
    limiteSuperiorPowerTX: number,
    limiteInferiorPowerTX: number,
    sourceHandle: string,
    targetHandle: string,
    viewTypeLabel: string,
    interfaceDescription: string,
    interfaceName: string,
    edgeLabelSize: number,
  ) => {
    try {
      setLoadinButtonEnlace(true);
      let updateConnection = connection;
      updateConnection.positionHandlers =
        edgeSelected?.data?.positionHandlers?.map((value: any) => {
          return { ...value, active: -1 };
        }) ?? [];
      updateConnection.config = {
        type: line ?? "reta",
        sourceHandle: sourceHandle || edgeSelected?.sourceHandle || "right",
        targetHandle: targetHandle || edgeSelected?.targetHandle || "left",
        capacidade,
        animation,
        hostOriginId: hostOriginId || null,
        flagLimiteAutomatico,
        flagCapacidadeAutomatica,
        limiteSuperiorPowerRX,
        limiteInferiorPowerRX,
        limiteSuperiorPowerTX,
        limiteInferiorPowerTX,
        viewType: viewTypeLabel,
        interfaceDescription,
        interfaceName,
        edgeLabelSize,
      };
      const response = await api.put("/easyMaps/link", updateConnection);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          setSnackbar({
            children: "Link atualizado com sucesso!",
            severity: "success",
          });
          let updateConnection = response.data.link;
          setConnections((prev) => {
            let next = new Map(prev);
            next.set(updateConnection.id, { ...updateConnection });
            return next;
          });
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação via socket"
        } `,
        severity: "error",
      });
    } finally {
      setLoadinButtonEnlace(false);
      setCheckChanges(false);
    }
  };
  const handleDeleteLink = async (id: string) => {
    try {
      const response = await api.delete("/easyMaps/link", { data: { id } });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        setElementSelected(null);
        if (response.data) {
          let updateConnection = response.data.link;
          setConnections((prev) => {
            let next = new Map(prev);
            next.delete(updateConnection.id);
            return next;
          });
          setSnackbar({
            children: "Link excluído com sucesso!",
            severity: "success",
          });
          setConnectionSelected(null);
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação via socket"
        } `,
        severity: "error",
      });
    }
  };
  //para caso de duplicar elemento
  const handleCreateElement = async (node: any) => {
    try {
      let data = structuredClone(elements.get(node.id)) as MapElement;

      data.titulo = data?.titulo + " (cópia)";
      if (data?.elementConfig?.config) {
        data.configuracao = {
          ...data.elementConfig.config,
          coordenadas: {
            long: Number(data.elementConfig.config.coordenadas?.long ?? 0) + 50,
            lat: Number(data.elementConfig.config.coordenadas?.lat ?? 0) + 50,
          },
        };
      }
      const response = await api.post("/easyMaps/element", data);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          setElements((prev) => {
            let next = new Map(prev);
            next.set(response.data?.element?.id, response.data?.element);
            return next;
          });
          setElementSelected(response.data?.element);
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação via socket"
        } `,
        severity: "error",
      });
    } finally {
      setCheckChanges(false);
    }
  };
  const handleDeleteElement = async (id: string) => {
    try {
      const logString = localStorage.getItem("logs");
      const logsId = logString ? JSON.parse(logString)?.id : null;

      const response = await api.delete("/easyMaps/element", {
        data: { id, logsLoginClienteId: logsId || "" },
      });
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível criar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConnections((prev) => {
            const targetId = response.data?.element?.id;
            if (!targetId) return prev;

            const next = new Map();
            prev.forEach((con, key) => {
              if (
                con.referenceId !== targetId &&
                con.destinationId !== targetId
              ) {
                next.set(key, con);
              }
            });
            return next;
          });
          setElements((prev) => {
            let next = new Map(prev);
            next.delete(response.data?.element?.id);
            return next;
          });
          setElementSelected(null);
          setConnectionSelected(null);
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação via socket"
        } `,
        severity: "error",
      });
    } finally {
      setCheckChanges(false);
    }
  };
  const handleUpdateElement = async (element: MapElement, node: any) => {
    let data = element;
    if (data?.elementConfig?.config) {
      data.configuracao = {
        ...data.elementConfig.config,
        coordenadas: {
          long: node?.position?.x,
          lat: node?.position?.y,
        },
      };
    }
    data.connections = {
      updates: true
        ? []
        : connectionsFromMap.filter(
            ({ referenceId, destinationId }) =>
              data.id === referenceId || data.id === destinationId,
          ),
      deletes: [],
    };
    try {
      const response = await api.put("/easyMaps/element", data);
      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível editar o elemento",
          severity: "error",
        });
      } else {
        if (response.data) {
          let updateElement = response.data.element;
          setElements((prev) => {
            let next = new Map(prev);
            next.set(updateElement.id, updateElement);
            return next;
          });
          if (elementSelected) setElementSelected({ ...updateElement });
        }
      }
    } catch (error: any) {
      setSnackbar({
        children: `Error:${
          error?.message || "Error na comunicação com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setCheckChanges(false);
    }
  };

  const changeConnection = (
    edgeId: string,
    updateConfig: any,
    updateData: any,
  ) => {
    setCheckChanges(true);

    setConnectionSelected((con) => {
      return {
        ...con,
        ...updateData,
        config: {
          ...con?.config,
          ...updateConfig,
        },
      };
    });
  };

  const changeElement = (
    elementId: string,
    updateConfig: any,
    updateData: any,
  ) => {
    console.log(updateConfig);

    setCheckChanges(true);

    setElementSelected((el) => {
      return {
        ...el,
        ...updateData,
        elementConfig: {
          ...el?.elementConfig,
          config: {
            ...el?.elementConfig?.config,
            ...updateConfig,
          },
        },
      };
    });
  };

  const handleCollapse = () => {
    setCollapse(!collapse);
  };

  const handleFullscreen = (value: boolean) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };
  const onImportComplete = async () => {
    setLoadingMap(true);
    await handleApiGetElements(id as string);
    setLoadingMap(false);
  };

  const addMapInMaps = (map: any) => {
    setMapas([...mapas, { nome: map?.titulo, tipo: map?.tipo, id: map?.id }]);
  };
  return (
    //Atenção: O contexto MapaContext é usado para compartilhar o estado do mapa e elementos entre os componentes filhos,
    // nas proximas atualizações usem essa forma para organizar o acesso aos dados do mapa.
    // Isso facilita a manutenção e a escalabilidade do código.
    // e Se possivel, removam os props desnecessários dos componentes filhos.
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "top",
        elements,
        setElements,
        elementSelected,
        setElementSelected,
        connections,
        setConnections,
        connectionSelected,
        setConnectionSelected,
        editMode,
        setEditMode,
        checkChanges,
        setCheckChanges,
        snackbar,
        setSnackbar,
        updateDataElementSocket,
        configurationMap,
        setConfigurationMap,
        hostsDataMap,
        alertsDataMap,
        connectionsDataMap,
        configElementDataMap,
        lastCollectData,
        connectionsDataMapPercentTraffic,
        connectionsDataMapPercentPower,
        soundState,
        setSoundState,
      }}
    >
      <ToastContainer
        style={styles.toastContainer}
        newestOnTop
        limit={isMobile ? 4 : 5}
      />
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMaps
            map={map}
            iconsElements={iconsElements}
            setFocusNodeId={setFocusNodeId}
            collapse={collapse}
            handleCollapse={handleCollapse}
            fullscreen={fullScreem}
          />
        )}
        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {editMode && (
            <Box sx={styles.editMode}>
              <Box sx={styles.dotEditMode}>
                <BarIcon width={"250px"} fill={theme.palette.secondary.main} />
                <Typography sx={styles.textEditMode}>Modo de Edição</Typography>
              </Box>
            </Box>
          )}
          {/* {editMode && (
            <Box sx={styles.editMode}>
              <Box sx={styles.dotEditMode}>
                <BarIcon width={"100%"} fill={theme.palette.secondary.main} />

                <Box sx={styles.rowContainer}>
                  <Typography sx={styles.textEditMode}>
                    Modo de Edição:
                  </Typography>

                  <Chip
                    icon={<FiberManualRecord sx={styles.chipDot} />}
                    label={
                      connectionMode === "selection" ? "Seleção" : "Conexão"
                    }
                    sx={styles.modeChip}
                  />
                </Box>
              </Box>
            </Box>
          )} */}
          {loadingMap && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" />
              <Typography fontSize="14px">
                Carregando dados do mapa...
              </Typography>
            </Box>
          )}{" "}
          <LoadingUpdate
            visible={sinc && !loadingMap}
            elementSelected={!!elementSelected}
          />
          <ReactFlowMapas
            setIconsElements={setIconsElements}
            setEdgeSelected={setEdgeSelected}
            setElementsConnected={setElementsConnected}
            iconsElements={iconsElements}
            setOpenRightBar={setOpenRightBar}
            focusNodeId={focusNodeId}
            handleCreateElement={handleCreateElement}
            handleDeleteElement={handleDeleteElement}
            handleCreateLink={handleCreateLink}
            handleDeleteLink={handleDeleteLink}
            handleUpdateLink={handleUpdateLink}
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            title={map?.titulo}
            setCoordenadasFlow={setCoordenadasFlow}
            edgeSelected={edgeSelected}
            coordenadasFlow={coordenadasFlow}
            openRightBar={openRightBar}
            setFocusNodeId={setFocusNodeId}
            socketCliente={socketCliente}
            mapas={mapas}
            addMapInMaps={addMapInMaps}
            produtos={produtos}
            changeConnection={changeConnection}
            loadinButtonEnlace={loadinButtonEnlace}
            onImportComplete={onImportComplete}
            connectionMode={connectionMode}
            setConnectionMode={setConnectionMode}
            xyZoomFromUrl={xyZoomFromUrl}
            changeElement={changeElement}
          />
        </Stack>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
      <AlertModal
        openModal={openAccessDenied}
        setOpenModal={setOpenAccessDenied}
        handleButton={() => navigate("/easyMaps/inicio")}
        severity="error"
        singleButton
        buttonText="Voltar"
        textContent="Você não tem permissão para acessar este mapa, solicite permissão ao administrador."
      />
    </MapaContext.Provider>
  );
};
export default MapaTopologia;
